import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import PublicLayout from "components/layouts/PublicLayout";
import NotFound from "pages/NotFound";
import ContractGenerator from './pages/contract-generator';
import FreelanceContractTemplatePage from './pages/freelance-contract-template-landing-page';
import NdaTemplatePage from './pages/nda-template-landing-page';
import ConsultancyContractTemplatePage from './pages/consultancy-contract-template-landing-page';
import AlgemeneVoorwaardenGeneratorPage from './pages/algemene-voorwaarden-generator-landing-page';
import FreelanceContractVoorbeeldPage from './pages/freelance-contract-voorbeeld-landing-page';
import SharedContract from './pages/shared-contract';
import FreelanceContractBelgiumPage from './pages/freelance-contract-belgium-landing-page';
import FreelanceContractNetherlandsPage from './pages/freelance-contract-netherlands-landing-page';
import NdaBelgiumLandingPage from './pages/nda-template-belgium-landing-page';
import NdaNetherlandsLandingPage from './pages/nda-template-netherlands-landing-page';
import FreelanceContractBeneluxPage from './pages/freelance-contract-template-benelux-landing-page';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<PublicLayout><ContractGenerator /></PublicLayout>} />
          <Route path="/contract-generator" element={<PublicLayout><ContractGenerator /></PublicLayout>} />
          <Route path="/contract/:id" element={<PublicLayout><SharedContract /></PublicLayout>} />
          <Route path="/freelance-contract-template" element={<PublicLayout><FreelanceContractTemplatePage /></PublicLayout>} />
          <Route path="/nda-template" element={<PublicLayout><NdaTemplatePage /></PublicLayout>} />
          <Route path="/consultancy-contract-template" element={<PublicLayout><ConsultancyContractTemplatePage /></PublicLayout>} />
          <Route path="/algemene-voorwaarden-generator" element={<PublicLayout><AlgemeneVoorwaardenGeneratorPage /></PublicLayout>} />
          <Route path="/freelance-contract-voorbeeld" element={<PublicLayout><FreelanceContractVoorbeeldPage /></PublicLayout>} />
          <Route path="/freelance-contract-belgium" element={<PublicLayout><FreelanceContractBelgiumPage /></PublicLayout>} />
          <Route path="/freelance-contract-netherlands" element={<PublicLayout><FreelanceContractNetherlandsPage /></PublicLayout>} />
          <Route path="/nda-template-belgium" element={<PublicLayout><NdaBelgiumLandingPage /></PublicLayout>} />
          <Route path="/nda-template-netherlands" element={<PublicLayout><NdaNetherlandsLandingPage /></PublicLayout>} />
          <Route path="/freelance-contract-template-benelux" element={<PublicLayout><FreelanceContractBeneluxPage /></PublicLayout>} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
